<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />
      <div class="login-content block-column">
        <div class="login-detail">
          <h2>セキュリティコードを入力</h2>
          <input type="text" #tbx_security plessInputTextSub
            [restrict]="'[ -￮]'" [(ngModel)]="model.emailOtpCode"
            [autofocus]="true" [tabindex]="0" [width]="'15rem'" />
        </div>
        <div class="layout_balance">
          <button class="btn-tartiary" (click)="eventReturnHanler()">戻る</button>
          <button class="left-button" id="btn_login" class="btn-primary"
            (click)="eventCheckMfaHandler()" [tabindex]="0">認証</button>
        </div>
      </div>
  </div>
</div>
  